export default __webpack_public_path__ + "static/media/illus03.65f1e6b3.png";